var map = {
	"./basketball.webp": 1656,
	"./bti-img.webp": 1657,
	"./bti-title-en.webp": 1658,
	"./cup.webp": 1659,
	"./football.webp": 1660,
	"./im-img.webp": 1661,
	"./im-title-en.webp": 1662,
	"./sb-img.webp": 1663,
	"./sb-title-cn.webp": 1664,
	"./sb-title-en.webp": 1665,
	"./sbo-img.webp": 1666,
	"./sbo-title-cn.webp": 1667,
	"./sbo-title-en.webp": 1668,
	"./sport-bg.webp": 1669,
	"./sport-ctg.webp": 1670,
	"./title-cn.webp": 1671,
	"./title-en.webp": 1672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 784;